<template>
  <TheBaseGrid :showEditor="true" @next="checkInput" editorHeight="208px">

    <template slot="intro">
      <h2>Opgave 5</h2>
      <h3>Flexbox model</h3>
      <p>
        Nu skal vi have logo og menu til at stå i hver sin side her skal bruges justify-content <span class="tool" id="exButton2">forklaring</span>.
      </p>
      <p>Du skal bruge display.</p>
      <b-tooltip target="exButton2" placement="bottom">
        <strong>Muligheder</strong>
        <ul>
          <li>flex-start</li>
          <li>flex-end</li>
          <li>center</li>
          <li>space-between</li>
          <li>space-around</li>
        </ul>
      </b-tooltip>
    </template>

    <template slot="cssInput">
      <pre class="before">.box {
    {{season[1].episode[$route.params.episodeNumber-5].cssInput}}
    {{season[1].episode[$route.params.episodeNumber-4].cssInput}}
    {{season[1].episode[$route.params.episodeNumber-3].cssInput}}
    {{season[1].episode[$route.params.episodeNumber-2].cssInput}}</pre>
      <textarea class="code-box__editor"
      v-model="season[1].episode[$route.params.episodeNumber-1].cssInput"
      style="height:24px" @keydown.prevent.enter="checkInput()"></textarea>
      <pre class="after">}</pre>
    </template>

    <template slot="output">
      <div class="box"
      :style="showStyle">
        <div class="logo">Logo</div>
        <div class="menu">Menu</div>
      </div>
    </template>

  </TheBaseGrid>
</template>

<script>
import { mapState } from 'vuex';
import TheBaseGrid from '@/components/TheBaseGrid.vue'
export default {
  name: 'episode1',
  components: {
    TheBaseGrid
  },
  computed: {
    ...mapState([
      'season'
    ]),
    showStyle (){
      let e = this.season[1].episode[this.$route.params.episodeNumber-5].cssInput
      let d = this.season[1].episode[this.$route.params.episodeNumber-4].cssInput
      let c = this.season[1].episode[this.$route.params.episodeNumber-3].cssInput
      let b = this.season[1].episode[this.$route.params.episodeNumber-2].cssInput
      let a = this.season[1].episode[this.$route.params.episodeNumber-1].cssInput
      return e+d+c+b+a
    }
  },
  methods: {
    checkInput(){
      let string = this.season[1].episode[this.$route.params.episodeNumber-1].cssInput
      if(string){
        if (!string.includes(';')) {
           alert("husk at afslut koden med semi kolon");
           return true
        }
        let jc = window.getComputedStyle(document.querySelector('.box')).justifyContent

        if(jc == 'space-between'){
          this.$router.push({ path: '/season/2/episode/6' })
        }else{
          alert("Du har en fejl i din kode prøv igen");
        }
      }else{
        alert("Du skal indtaste koden i den hvide boks");
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.box{
  background-color: lightgreen;
}

</style>
